'use strict';

exports.__esModule = true;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.lookup = lookup;
exports.get = get;
exports.getById = getById;
exports.add = add;
exports.remove = remove;
exports.update = update;

var _http = require('../network/http');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_ADDRESS: '/customer/addresses',
  CUSTOMER_ADDRESS_LOOKUP: '/customer/addresses/lookup'
};

var addresses = {
  lookup: lookup,
  get: get,
  add: add,
  getById: getById,
  remove: remove
};

exports.default = addresses;

/**
 * Wrapper for `/customer/addresses` API endpoint
 */

/**
 * Get all addresses by filter
 * @param {string} postcode - postcode of the supported area
 * @param {string} locationId - id of the user location
 * @returns {promise} containing the entity array of addresses
 */

function lookup(postcode, locationId) {
  return (0, _http.get)(API.CUSTOMER_ADDRESS_LOOKUP, { locationId: locationId, query: postcode });
}

/**
 * Get all addresses
 * @param {Object} address - Address model.
 * @returns {promise} containing the entity array of addresses
 */
function get(params) {
  return (0, _http.get)(API.CUSTOMER_ADDRESS, params);
}

/**
 * Get address by id
 * @param {Object} id - locationId.
 * @returns {promise} containing the object of the address
 */
function getById(locationId) {
  return (0, _http.get)(API.CUSTOMER_ADDRESS + '/' + locationId);
}

/**
 * Add new address
 * @param {(string|Object[])} nameOrConfig - display name or config object for address,
 * set as null to not associate with favourites
 * @param {string} address1 - house name or number
 * @param {string} [address2] - street name
 * @param {string} town - town name
 * @param {string} [county] - county name
 * @param {string} postcode - postcode of the supported area
 * @param {string} [contactName] - name of person at address
 * @param {string} [phone] - phone number at address
 * @returns {promise} containing the entity object of the location
 */
function add(nameOrConfig, address1, address2, town, county, postcode, contactName, phone) {
  var addressParams = nameOrConfig;
  if ((typeof nameOrConfig === 'undefined' ? 'undefined' : (0, _typeof3.default)(nameOrConfig)) !== 'object') {
    addressParams = { nameOrConfig: nameOrConfig, address1: address1, address2: address2, town: town, county: county, postcode: postcode, contactName: contactName, phone: phone };
  }
  return (0, _http.post)(API.CUSTOMER_ADDRESS, addressParams);
}

/**
 * Remove address by id
 * @param {Object} id - locationId.
 * @returns {promise} containing the object of the removed address
 */
function remove(id) {
  return (0, _http.remove)(API.CUSTOMER_ADDRESS + '/' + id);
}

/**
 * Update an existing address
 * @param {Object} data
 * @returns {promise} containing the updated location entity
 */
function update(id, data) {
  return (0, _http.put)(API.CUSTOMER_ADDRESS + '/' + id, data);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/addresses.js
// module id = 1086
// module chunks = 0